export const rootStyles = {
	display: 'flex',
};

export const iconContainerStyles = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: {
		xs: '100%',
		sm: '100%',
		md: '40%',
	},
};

export const iconShadowStyles = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '90px',
	height: '90px',
	borderRadius: '50%',
	backgroundColor: 'background.default',
};

export const iconStyles = {
	fontSize: '60px',
	stroke: '#9e9e9e',
	fill: 'white',
};

export const infoContainerStyles = {
	flexGrow: 1,
	width: {
		xs: '100%',
		sm: '100%',
		md: '60%',
	},
};
